import React from 'react';
import block from 'bem-cn-lite';

import './Breadcrumbs.scss';

const b = block('Breadcrumbs');

export interface BreadcrumbItem {
    name: string;
    url?: string;
}

export interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    delimiter?: 'slash' | 'arrow';
    depth?: number;
    className?: string;
}

export default class Breadcrumbs extends React.Component<BreadcrumbsProps> {
    static defaultProps = {
        delimiter: 'slash',
    };

    render() {
        const {delimiter, depth, className} = this.props;

        if (!this.props.items) {
            return null;
        }

        const items = depth ? this.props.items.slice(0, depth) : this.props.items;

        return (
            <nav className={b(null, className)} aria-label="Breadcrumbs">
                <ol className={b('items')}>
                    {items.map((item, index, subItems) => (
                        <li key={index} className={b('item', {delimiter})}>
                            {this.renderItem(item, index === subItems.length - 1)}
                        </li>
                    ))}
                </ol>
            </nav>
        );
    }

    private renderItem({name, url}: BreadcrumbItem, isLast: boolean) {
        const hasUrl = Boolean(url);
        return React.createElement(
            hasUrl ? 'a' : 'span',
            {
                className: b('text', {link: hasUrl}),
                href: url,
                ['aria-current']: isLast ? 'page' : null,
            },
            name,
        );
    }
}
